
import AssessmentListComponent from "src/components/Assessment/AssessmentListHOC";

const ActiveAssessments = () => {
  return (
    <AssessmentListComponent status='active' label='Active' />
  )
}

export default ActiveAssessments;